import React from 'react'
import ReactWOW from 'react-wow';
export default class Info extends React.Component {
    constructor(props) {
        super(props);
        
    }

    render() {
        const informationList = [];
        if(this.props.infoList != undefined) {
            this.props.infoList.forEach((info, index) => {
                // Create list for bullets
                const bulletList = [];
                info.infoBullets.forEach((bullet,index) => {
                    let delayString = '';
                    switch(index) {
                        case 0:
                            delayString = '0.5s'
                            break;
                        case 1:
                            delayString = '0.7s'
                            break;
                        case 2:
                            delayString = '0.9s'
                            break;
                        default: 
                            break;
                    }
                    bulletList.push(
                        <ReactWOW animation="fadeInUp" delay={delayString}>
                            <li><span>{bullet.name} </span>{bullet.description}</li>
                        </ReactWOW>
                    )
                });
                informationList.push(
                    <div className={`row h_analytices_features_item ${(index%2 != 0 ? 'flex-row-reverse' : '')}`}>

                        <div className="col-12">
                        </div>
                        <div className="col-lg-6">
                            <div className="h_analytices_img">
                                <ReactWOW animation="fadeInLeft" delay="0.3s">
                                    <img className="background" src={info.mockupImage} alt="Screenshot" />
                                </ReactWOW>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="h_analytices_content">
                                <ReactWOW animation="fadeInUp" delay="0.1s">
                                    <h2>{info.infoTitle}</h2>
                                </ReactWOW>
                                <ReactWOW animation="fadeInUp" delay="0.3s">
                                    <p>{info.infoSubtitle}</p>
                                </ReactWOW>
                                <ul className="list-unstyled">
                                    {bulletList}
                                </ul>
                            </div>
                        </div>
                    </div>
                )
            });
        }
        return (
            <section className="h_analytices_features_area">

                <div className="container">
                    {informationList}
                    <div className="text-center wow fadeInUp" data-wow-delay="0.3s">
                        {/* <a href="/signup" className="er_btn">Sign Up For Free</a> */}
                    </div>
                </div>
            </section>
        )
    }
}